import LocalizedStrings from "react-localization";
import en from "./en/translations.json";
import hu from "./hu/translations.json";
import sr from "./sr/translations.json";

const translations = new LocalizedStrings({
  en,
  hu,
  sr,
});

export default translations;
